module.exports = __webpack_public_path__ + "static/media/vail-2.3e32ef83.jpg";